import { NApiConfig } from "./napi.config.interface";

export default (): NApiConfig => ({
    url: process.env.REACT_APP_NEWSLETTERTOOL_API ?? '',
});